<template>
  <div class="FormSMSInput form-group" :class="{ row: horizontal }" :style="marginStyle">
    <template>
      <transition enter-active-class="animated fadeIn short" leave-active-class="animated fadeout short">
        <label class="formLabel" v-show="value && value.length > 0">{{ label }}</label>
      </transition>
      <input id="smsInput" v-bind="$attrs" autocomplete="off" class="form-control" :value="value" @input="handleInput($event.target.value)">
      <button v-if="!sent" type="button" class="btn btn-link smsBtn" @click="fetchSMSCode" tabindex="-1">
        获取验证码
      </button>
      <p v-else class="countdownMsg">{{ countdown }}s后重新获取</p>
    </template>
  </div>
</template>

<script>
import { validTelephone } from '@/utils/validators'
import authApi from '@/services/auth/index'
import marginProps from '@/mixins/marginProps'
import { mapGetters } from 'vuex'

export default {
  mixins: [marginProps],
  props: {
    horizontal: {
      type: Boolean,
      default: false
    },
    label: String,
    telephone: [Number, String],
    value: {
      type: [String, Number, Object]
    },
    type: {
      // 1登录 2更改密码 3更改手机号
      type: [String, Number],
      default: 1
    },
    from: String,
    isZby: {
      type: Boolean,
      default: false
    },
    isCaptcha: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      intervalId: 0,
      sent: false,
      countdown: 60,
      params: {}
    }
  },
  methods: {
    /** handlers */
    handleInput (value) {
      this.$emit('input', value)
    },
    startCountdown () {
      this.countdown = 60
      this.sent = true
      this.intervalId = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--
        } else {
          this.sent = false
          clearInterval(this.intervalId)
        }
      }, 1000)
    },
    /** fetchers */
    fetchSMSCode () {
      // this.$emit('status-change') // 点击过获取验证码，外部只监听一次
      let params = {
        type: this.type, // for login
        from: this.isZby ? 2 : 1
      }
      if (this.from === 'resetPassword') {
        params.key = this.telephone
      } else {
        params.telephone = this.telephone
      }
      if (this.isCaptcha) {
        this.$emit('captcha', params)
      } else {
        // params.country_id = this.loggedUser.country_id ? this.loggedUser.country_id : ''
        if (!validTelephone(this.telephone)) {
          return this.$toast.warning('手机号不合法')
        }
        return authApi.fetchSMSCode(params).then(res => {
          if (res && res.ok) {
            this.startCountdown()
            this.$emit('status-change')
          }
        })
      }
    }
  },
  computed: {
    ...mapGetters(['loggedUser'])
  }
}
</script>

<style scoped lang="scss">
.FormSMSInput {
  position: relative;
  label {
    font-size: 14px;
    color: #b4b4b4;
  }
  input {
    font-size: 14px;
    padding-left: 0;
    border: none;
    border-bottom: 1px solid #eee;
    &:focus {
      outline: none;
      box-shadow: none;
    }
  }
  .smsBtn {
    position: absolute;
    padding: 0;
    right: 0px;
    bottom: 4px;
    outline: none;
    font-size: 14px;
    color: $mainColor;
  }
  .countdownMsg {
    position: absolute;
    padding: 0;
    right: 0px;
    bottom: 8px;
    color: #b4b4b4;
    font-size: 14px;
  }
  .hz-fix {
    right: 12px;
  }
  .formLabel {
    font-size: 14px;
    position: absolute;
    top: -20px;
    left: 0;
  }
}
</style>
